import * as React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Grid,
  CardActionArea,
} from "@mui/material";
import { baseUrl } from "../../helper/urls";
import { useNavigate } from "react-router-dom";
import ShareModal from "./ShareModal";

export default function MultiActionAreaCard({ blogList }) {
  const navigate = useNavigate();

  const handleCardClick = (title_url) => {
    navigate(`/blog/${title_url}`);
  };

  const [openModal, setOpenModal] = React.useState(false);
  const [selectedBlog, setSelectedBlog] = React.useState(null);

  const handleShareClick = (blog) => {
    setSelectedBlog(blog);
    setOpenModal(true);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, padding: 4 }}>
        <Grid container spacing={2} justifyContent="center">
          {blogList &&
            blogList.map((blog, index) => (
              <Grid item key={index}>
                <Card
                  sx={{
                    width: 300,
                    height: 340,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <CardActionArea
                    onClick={() => handleCardClick(blog.title_url)}
                    sx={{ height: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      image={`${baseUrl}${blog.image_url}`}
                      alt={blog.title}
                      sx={{
                        height: 155,
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <CardContent
                      sx={{
                        height: 185,
                        padding: "8px 16px !important",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        gutterBottom
                        variant="h6"
                        noWrap
                        sx={{ fontSize: 16 }}
                      >
                        {blog.title}
                      </Typography>

                      <Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            display: "-webkit-box",
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {blog.description}
                        </Typography>

                        <Typography
                          variant="body2"
                          align="right"
                          sx={{
                            color: "#124178",
                            fontWeight: 300,
                            cursor: "pointer",
                            mt: 1,
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent card click
                            handleCardClick(blog.title_url);
                          }}
                        >
                          Read More 
                        </Typography>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Box>

      {selectedBlog && (
        <ShareModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          blogTitle={selectedBlog.title}
          shareUrl={`${window.location.origin}/blog/${selectedBlog.title_url}`}
        />
      )}
    </>
  );
}

// import * as React from "react";
// import {
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Button,
//   CardActionArea,
//   CardActions,
//   Box,
//   IconButton,
//   Grid,
// } from "@mui/material";
// import ShareIcon from "@mui/icons-material/Share";
// import { baseUrl } from "../../helper/urls";
// import { useNavigate } from "react-router-dom"; // Add
// import ShareModal from "./ShareModal";
// export default function MultiActionAreaCard({ blogList }) {
//   const navigate = useNavigate();

//   const handleCardClick = (title_url) => {
//     navigate(`/blog/${title_url}`);
//   };

//   const [openModal, setOpenModal] = React.useState(false);
//   const [selectedBlog, setSelectedBlog] = React.useState(null);
//   const handleShareClick = (blog) => {
//     setSelectedBlog(blog);
//     setOpenModal(true);
//   };

//   return (
//     <>
//       <>
//         <Box sx={{ flexGrow: 1, padding: 4 }}>
//           <Grid container spacing={2} justifyContent="center">
//             {blogList &&
//               blogList.map((blog, index) => (
//                 <Grid item key={index}>
//                   <Card
//                     sx={{
//                       width: 300,
//                       height: 340,
//                       display: "flex",
//                       flexDirection: "column",
//                       overflow: "hidden",
//                     }}
//                   >
//                     <CardActionArea
//                       onClick={() => handleCardClick(blog.title_url)}
//                     >
//                       <CardMedia
//                         component="img"
//                         image={`${baseUrl}${blog.image_url}`}
//                         alt={blog.title}
//                         sx={{
//                           height: 155,
//                           width: "100%",
//                           objectFit: "cover",
//                         }}
//                       />
//                       <CardContent
//                         sx={{
//                           height: 185,
//                           // bgcolor: "#e2e9f1",
//                           padding: "8px 16px !important",
//                           overflow: "hidden",
//                         }}
//                       >
//                         <Typography
//                           gutterBottom
//                           variant="h6"
//                           noWrap
//                           sx={{ fontSize: 16 }}
//                         >
//                           {blog.title}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             color: "text.secondary",
//                             display: "-webkit-box",
//                             WebkitLineClamp: 6,
//                             WebkitBoxOrient: "vertical",
//                             overflow: "hidden",
//                           }}
//                         >
//                           {blog.description}
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>

//                     {/* <CardActions
//                       sx={{
//                         height: 40,
//                         // bgcolor: "#dde4ec",
//                         padding: "8px",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                       }}
//                     >
//                       <IconButton
//                         size="small"
//                         onClick={() => handleShareClick(blog)}
//                       >
//                         <ShareIcon fontSize="small" sx={{ color: "#124178" }} />
//                       </IconButton>

//                       <Button
//                         size="small"
//                         variant="contained"
//                         sx={{
//                           textTransform: "none",
//                           flexGrow: 1,
//                           bgcolor: "#124178",
//                         }}
//                         onClick={() => handleCardClick(blog.title_url)}
//                       >
//                         Read More...
//                       </Button>
//                     </CardActions> */}
//                   </Card>
//                 </Grid>
//               ))}
//           </Grid>
//         </Box>
//       </>
//       <>
//         {selectedBlog && (
//           <ShareModal
//             open={openModal}
//             onClose={() => setOpenModal(false)}
//             blogTitle={selectedBlog.title}
//             shareUrl={`${window.location.origin}/blog/${selectedBlog.title_url}`}
//           />
//         )}
//       </>
//     </>
//   );
// }
